import PropTypes from 'prop-types';

export const LinkProps = PropTypes.shape({
  id: PropTypes.string,
  entityId: PropTypes.string,
  entityType: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string
});

export const LinkDefaults = {
  id: null,
  entityId: null,
  entityType: null,
  type: '',
  title: '',
  description: '',
  url: ''
};
